<template>
    <div class="eda-oli"
         @mouseover="hover = true"
         @mouseleave="hover=false"
         @click="goToOrder">

        <div class="eda-oli__meta">
            <div class="eda-oli__title">
                {{ title }}
            </div>

            <div class="eda-oli__date">
                {{ created.date | formatDateShort }} {{ created.date | formatTime }}
            </div>
        </div>


        <div class="eda-oli__customer">
            {{ customerFullName }}
        </div>

        <div class="eda-oli__solution">
            <template v-for="line in orderLines">
                <div class="eda-oli__line" v-bind:key="line.id">

                    <svg class="eda-oli__dot" viewBox="0 0 10 10" xmlns="http://www.w3.org/2000/svg">
                        <circle cx="5" cy="5" r="5"/>
                    </svg>
                    <span class="eda-oli__item">
                    {{ line.name  }}
                    </span>
                </div>
            </template>
        </div>



        <div class="eda-oli__admin-status">

            <div class="eda-oli__status-label">
                Administrasjon:
            </div>

            <div class="eda-oli__status-value">
                <eda-status :status="orderStatus"></eda-status>
            </div>


            <div class="eda-oli__flag" v-if="administratorAttentionNeeded">
                {{ flagOptions.administratorAttentionNeeded.label }}
            </div>

            <div class="eda-oli__flag" v-if="retailerAttentionNeeded">
                {{ flagOptions.retailerAttentionNeeded.label }}
            </div>
        </div>


        <div class="eda-oli__installation-status">
            <div class="eda-oli__status-label">
                Installasjon:
            </div>
            <div class="eda-oli__status-value">
                <eda-status :status="installationStatus"></eda-status>
            </div>

        </div>


        <div class="eda-oli__go" :class="{'eda-oli__go--hover': hover}">
            <eda-icon icon="arrow-right" fill="black"></eda-icon>
        </div>

    </div>
</template>

<script>
  import EdaIcon from "./vIcon";
  import EdaStatus from "./vStatus";
  import FLAGS from "../config/flags/config.js";

  export default {
    name: "eda-order-list-item",
    components: {
      EdaIcon,
      EdaStatus
    },
    data: function () {
      return {
        hover: false
      }
    },
    props: {
      id: { type: String, default: "" },
      title: { type: String, default: "" },
      retailer: { type: String, default: "" },
      retailerOrderRef: { type: String, default: "" },
      customerFullName: { type: String, default: "" },
      customerEmail: { type: String, default: "" },
      customerPlace: { type: String, default: "" },
      customerPhone: { type: String, default: "" },
      customerMeterNumber: { type: String, default: "" },
      customerAddressLine1: { type: String, default: "" },
      customerCarBrand: { type: String, default: "" },
      customerCarModel: { type: String, default: "" },
      orderSolutionName: { type: String, default: "" },
      orderStatus: { type: String, default: "" },
      orderStatusLabel: { type: String, default: "" },
      orderLines: {
        type: Array, default: function () {
          return []
        }
      },
      orderNotes: { type: String, default: "" },
      created: {
        type: Object, default: function () {
          return {}
        }
      },

      installationStatus: { type: String, default: "" },
      retailerAttentionNeeded: { type: Boolean, default: false },
      administratorAttentionNeeded: { type: Boolean, default: false },
      updated: {
        type: Object, default: function () {
          return {}
        }
      }
    },

    computed: {
      // make flag options easier to use in templates
      flagOptions() {
        return FLAGS.reduce(function (result, item) {
          result[item.value] = item;
          return result;
        }, {})
      }


    },
    methods: {
      goToOrder() {
        this.$router.push("/orders/" + this.id);
      }
    }

  }
</script>

<style lang="scss">
    .eda-oli {
        cursor: pointer;
        text-align: left;
        font-weight: 300;
        padding: 1em 1.5em;
        display: flex;
        justify-content: space-between;
        max-width: 70em;
        margin: 0 auto;
        flex-wrap: wrap;

        background-color: white;

        &__flag {
            font-size: .85em;
            color: #ff796c;
        }
    }

    .eda-oli:hover {
        background-color: #f5fff5;
    }

    .eda-oli__line {
        padding-top: 0.2em;
        font-size: 0.8em;
        color: #215f4c;
        padding-bottom: 0.35em;

    }

    .eda-oli__dot {
        display: none;
        width: 0.35em;
        margin-right: 0.35em;
        margin-bottom: 0.15em;
        fill: #333;
    }

    .eda-oli__meta {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
    }

    .mq-mobile .eda-oli__meta,
    .mq-tablet .eda-oli__meta {
        width: 100%;
        flex-direction: row;

    }

    .eda-oli__title {
        width: 8em;
        font-size: .9em;
        flex: none;
    }

    .eda-oli__date {
        padding-top: 0.5em;
        font-size: 0.8em;
        color: #777;
        flex: none;
    }

    .eda-oli__customer {
        width: 14em;
        font-size: .9em;
        flex: none;
    }

    .eda-oli__solution {
        font-weight: 400;
        width: 15em;
        flex: none;
    }

    .eda-oli__status {
    }

    .eda-oli__installation-status {
        width: 6em;
        flex: none;

    }
    .eda-oli__admin-status {

        width: 8em;
        flex: none;
    }

    .eda-oli__status-label {
        padding-bottom: .1em;
        font-size: .6em;
    }

    .eda-oli__status-value {
        font-weight: 500;
        font-size: .7em;
    }

    .eda-oli__go {
        margin-right: 0.5em;
        opacity: 0.3;
        width: 1.75em;
        height: 1.75em;
        transition: all 0.2s ease;
    }

    .eda-oli__go--hover {
        transform: translateX(0.25em);
    }

</style>